import { REQUEST_BUILD_BUNDLES, RECEIVE_BUILD_BUNDLES, UPDATE_BUILD_BUNDLES_VALUES, CLEAR_BUILD_BUNDLES_VALUES} from '../constants/actionTypes';
import { displayError } from './helpers';
import { hideBuildBundlesModal } from './modal';
import { getBackendUrl } from '../env';


const requestBuildBundles = ({
    type: REQUEST_BUILD_BUNDLES
});

const receiveBuildBundles = ({
    type: RECEIVE_BUILD_BUNDLES
});

export const updateBuildBundlesValues = values => ({
    type: UPDATE_BUILD_BUNDLES_VALUES,
    values: values
});

export const clearBuildBundlesValues = () => ({
    type: CLEAR_BUILD_BUNDLES_VALUES,
});

export const startBundleBuild = (branchName, sceneName) => dispatch => {
    dispatch(requestBuildBundles);

    let payload = {
        branchName: branchName,
        sceneName: sceneName
    }

    return fetch(`${getBackendUrl()}/api/v1/bundles/buildBundles`, {
        method: 'POST',
        body:JSON.stringify(payload),
        headers: { 'Content-Type': 'application/json' }
    })
    .then( (response) => {
        if(!response.ok){
            throw Error(response.statusText)
        }

        dispatch(receiveBuildBundles);
        dispatch(clearBuildBundlesValues());
        dispatch(hideBuildBundlesModal());
    })
    .catch(err => {
        dispatch(receiveBuildBundles);
        dispatch(displayError(err));
    });
}



// WEBPACK FOOTER //
// ./src/actions/bundles.js